import { useLocation } from "react-router";
import { useMemo } from "react";
import { Offcanvas } from "react-bootstrap";
import SlideMobileSelectAsset from "./slides/SlideMobileSelectAsset";
import SlideMobileAccountStat from "./slides/SlideMobileAccountStat/SlideMobileAccountStat";
import SlideMobileAssetInfo from "./slides/SlideMobileAssetInfo";
import { MOBILE_SLIDER_PAGES_IDS } from "./mobileSliderPagesConstants";
import SlideMobileDeposit from "./slides/SlideMobileDeposit";
import SlideMobilePosition from "./slides/SlideMobilePosition";
import SlideMobilePositionCreate from "./slides/SlideMobilePositionCreate";
import SlideMobileHistory from "./slides/SlideMobileHistory/SlideMobileHistory";
import SlideMobileVerify from "./slides/SlideMobileVerify";
import SlideMobileWithdraw from "./slides/SlideMobileWithdraw";
import SlideMobileWithdrawalRequestSent from "./slides/SlideMobileWithdrawalRequestSent";
import SlideMobileSettings from "./slides/SlideMobileSettings";
import SlideMobileEmailConfirmed from "./slides/SlideMobileEmailConfirmed";
import SlideMobileRespawn from "./slides/SlideMobileRespawn.jsx";
import SlideMobilePositionUpdate from "./slides/SlideMobilePositionUpdate";
import SlideMobileHistoryInfo from "./slides/SlideMobileHistoryInfo/SlideMobileHistoryInfo";
import SlideMobileDepositSurvey from "./slides/SlideMobileDepositSurvey";

const MOBILE_SLIDER_PRIVATE_PAGES_COMPONENTS = {
    [MOBILE_SLIDER_PAGES_IDS.ACCOUNT_STAT]: SlideMobileAccountStat,
    [MOBILE_SLIDER_PAGES_IDS.ASSETS]: SlideMobileSelectAsset,
    [MOBILE_SLIDER_PAGES_IDS.ASSET]: SlideMobileAssetInfo,
    [MOBILE_SLIDER_PAGES_IDS.DEPOSIT]: SlideMobileDeposit,
    [MOBILE_SLIDER_PAGES_IDS.DEPOSIT_SURVEY]: SlideMobileDepositSurvey,
    [MOBILE_SLIDER_PAGES_IDS.EMAIL_CONFIRMED]: SlideMobileEmailConfirmed,
    [MOBILE_SLIDER_PAGES_IDS.POSITION_UPDATE]: SlideMobilePositionUpdate,
    [MOBILE_SLIDER_PAGES_IDS.POSITION_CREATE]: SlideMobilePositionCreate,
    [MOBILE_SLIDER_PAGES_IDS.POSITION_INFO]: SlideMobilePosition,
    [MOBILE_SLIDER_PAGES_IDS.RESPAWN]: SlideMobileRespawn,
    [MOBILE_SLIDER_PAGES_IDS.SETTINGS]: SlideMobileSettings,
    [MOBILE_SLIDER_PAGES_IDS.HISTORY]: SlideMobileHistory,
    [MOBILE_SLIDER_PAGES_IDS.HISTORY_INFO]: SlideMobileHistoryInfo,
    [MOBILE_SLIDER_PAGES_IDS.VERIFY]: SlideMobileVerify,
    [MOBILE_SLIDER_PAGES_IDS.WITHDRAWAL_REQUEST_SENT]: SlideMobileWithdrawalRequestSent,
    [MOBILE_SLIDER_PAGES_IDS.WITHDRAW]: SlideMobileWithdraw,
}

const mobileSliderPrivatePagesComponentsList = Object.entries(MOBILE_SLIDER_PRIVATE_PAGES_COMPONENTS);

function MobileSliderPrivatePages() {
    const {search} = useLocation();

    const [openedPageId] = useMemo(() => {
        const params = new URLSearchParams(search);
        const openedPageId = params.get('s');
        return [openedPageId];
    }, [search]);

    return mobileSliderPrivatePagesComponentsList.map(([pageId, Component]) => (
        <Offcanvas key={pageId} show={openedPageId === pageId} placement="end" style={{width: "100%"}}>
            <Component/>
        </Offcanvas>
    ))
}

export default MobileSliderPrivatePages;
